import URL from "core/resources/urls";
import http from "infra/http";
import { useQuery } from "react-query";
import { OperacoesExecutadas, TipoMapaTalhoes } from "../typings";

export function useOperacoesExecutadas(
  unidadeId: string,
  safraId: string,
  tipoMapa: TipoMapaTalhoes
) {
  return useQuery(
    URL.MAPAS.OPERACOES_EXECUTADAS(unidadeId!, safraId!),
    async () => {
      if (unidadeId && safraId) {
        const { data } = await http.get<OperacoesExecutadas>(
          URL.MAPAS.OPERACOES_EXECUTADAS(unidadeId!, safraId!)
        );

        return data;
      }
    },
    {
      enabled: tipoMapa === TipoMapaTalhoes.OperacoesExecutadas,
    }
  );
}
